import React from "react";
import "./CampusCss/RaithalCampus.css";

const RaithalCampus = () => {
  return (
    <div className="gurukul-containerRT">

      {/* Header Section */}
      <header className="headerRT">
        <div className="header-contentRT">
          <h1>Shri Kheteshwar Gurukul</h1>
          <h2>Raithal, Jalore, Rajasthan</h2>
          <div className="header-decorationRT"></div>
        </div>
      </header>

      {/* Introduction */}
      <section className="introRT">
        <div className="intro-contentRT">
          <div className="intro-textRT">
            <h2>Nurturing Young Minds with Vedic Values</h2>
            <p>
              Our newest Gurukul at <strong>Raithal, Jalore</strong> provides quality primary education
              with a focus on traditional values and modern learning. With <strong>31 students</strong> currently
              enrolled, we offer a nurturing environment under the <strong>Rajasthan Board of Secondary Education (RBSE)</strong>.
            </p>
            <div className="feature-gridRT">
              <div className="feature-boxRT">
                <div className="feature-iconRT">🎓</div>
                <h4>Primary Education</h4>
              </div>
              <div className="feature-boxRT">
                <div className="feature-iconRT">🚌</div>
                <h4>Day Boarding</h4>
              </div>
              <div className="feature-boxRT">
                <div className="feature-iconRT">🙏</div>
                <h4>Vedic Values</h4>
              </div>
            </div>
          </div>
          <img src="/raithal1.jpg" alt="Raithal Gurukul" className="main-imageRT" />
        </div>
      </section>

      {/* Gallery Section */}
      <section className="galleryRT">
        <div className="section-headerRT">
          <h2>Campus Gallery</h2>
          <p className="section-subtitleRT">Glimpses of our Gurukul life</p>
        </div>
        <div className="gallery-gridRT">
          <img src="/raithal1.jpg" alt="Raithal Campus 1" className="gallery-imageRT" />
          <img src="/raithal2.jpg" alt="Raithal Campus 2" className="gallery-imageRT" />
          <img src="/raithal3.jpg" alt="Raithal Campus 3" className="gallery-imageRT" />
          <img src="/raithal4.jpg" alt="Raithal Campus 4" className="gallery-imageRT" />
          <img src="/raithal5.jpg" alt="Raithal Campus 5" className="gallery-imageRT" />
        </div>
      </section>

      {/* Stats Section */}
      <section className="statsRT">
        <div className="section-headerRT">
          <h2>Gurukul Overview</h2>
        </div>
        <div className="stats-gridRT">
          <div className="stat-cardRT">
            <div className="stat-iconRT">👦👧</div>
            <h3>31</h3>
            <p>Students (Rishi Kumar & Rishi Kanya)</p>
          </div>
          <div className="stat-cardRT">
            <div className="stat-iconRT">👨‍🏫</div>
            <h3>3-4</h3>
            <p>Teachers</p>
          </div>
          <div className="stat-cardRT">
            <div className="stat-iconRT">👥</div>
            <h3>1-2</h3>
            <p>Non-Teaching Staff</p>
          </div>
          <div className="stat-cardRT">
            <div className="stat-iconRT">📚</div>
            <h3>Primary</h3>
            <p>Class Level</p>
          </div>
        </div>
      </section>

      {/* Facilities Section */}
      <section className="facilitiesRT">
        <div className="section-headerRT">
          <h2>Facilities & Details</h2>
        </div>
        <div className="facility-cardsRT">
          <div className="facility-cardRT">
            <h3>🏫 Day Boarding</h3>
            <p>Day boarding facility available for students with proper care and supervision throughout the day.</p>
          </div>
          <div className="facility-cardRT">
            <h3>📋 Board</h3>
            <p>Affiliated to <strong>Rajasthan Board of Secondary Education (RBSE)</strong></p>
          </div>
          <div className="facility-cardRT">
            <h3>💰 Fee Structure</h3>
            <p>No annual fees! Only <strong>₹500 registration fee</strong>. Teaching expenses covered by <strong>Samaj Shiksha Nidhi Samarpan Yojana</strong>.</p>
          </div>
          <div className="facility-cardRT">
            <h3>📖 Education</h3>
            <p>Primary level education with focus on Vedic values, Sanskrit, and modern subjects.</p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contactRT">
        <div className="section-headerRT">
          <h2>Contact Us</h2>
        </div>
        <div className="contact-infoRT">
          <p><strong>Address:</strong> Raithal, Jalore, Rajasthan</p>
          <p><strong>Phone:</strong> 9492821008, 9951615155, 9160221008, 9603551008</p>
          <p><strong>Email:</strong> kheteshwargurukul1@gmail.com</p>
        </div>
      </section>

    </div>
  );
};

export default RaithalCampus;
